/**
 * Case- and accent-insensitive search text: lower case, combining marks dropped, `đ` counted as `d`, runs of
 * white space as one, trimmed. The server's SQL `fold_search(text)` (migration 012) is the same function, so a
 * word typed here finds on the server what it finds in the browser.
 */
export function normalizeSearch(text: string): string {
  return text.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '').replace(/đ/g, 'd').replace(/\s+/g, ' ').trim();
}

/** Whether the folded `needle` occurs in the folded `haystack`; an empty needle matches everything. */
export function matchesSearch(haystack: string, needle: string): boolean {
  return normalizeSearch(haystack).includes(normalizeSearch(needle));
}
